'use strict';

import $ from 'jquery';
import _ from 'underscore';
import mediator from '../../js/mediator';
import Backbone from 'backbone';
import config from '../../js/config';
import utilities from '../../js/utilities';
import ProductImpression from '../ProductImpressions/ProductImpression';
import { EnableAdobeAnalytics } from '../../utilities/featureFlags';
import Analytics from  '../Analytics/Analytics';

import 'slick-carousel';

var CarouselBaseView = Backbone.View.extend({
  options: {
    editorMode: false,
    autoplay: true,                 // Whether to automatically change slide
    arrows: true,
    pagination: true,               // Whether to show pagination dots
    paginationClass: 'slick-dots',
    slideClass: '', // Slide selector
    slidesToShow: 1,
    slidesToScroll: 1,
    swipeToSlide: false,
    draggable: false,
    swipe: true,
    touchMove: false,
    fade: false,
    infinite: true,
    easing: 'linear',               // The animation easing
    speed: 400,                     // Speed of the animation
    delay: 5000,                    // How long a slide is shown
    vertical: false,
    prevArrow: '<button type="button" data-role="none" class="slick-prev" aria-label="previous">Previous</button>',
    nextArrow: '<button type="button" data-role="none" class="slick-next" aria-label="next">Next</button>',
    customPaging: function(a, b) {
      return '<button type="button" data-role="none">' + (b + 1) + '</button>';
    },
    responsive: null,
    variableWidth: false,
    respondTo: 'window',
    touchThreshold: 5,
    mobileFirst: false,
    slickMaxBreakpoint: false,
    slickMinBreakpoint: false,
    disableAutoPlayWhenOutOfViewport: true
  },

  initialize: function(options) {

    if (utilities._isMobileOrTabletDevice()) {
      options.autoplay = false;
      if (this.options) {
        this.options.autoplay = false;
      }
    }

    this.options = _.defaults(options || {}, this.options);

    // Assign the view to a jQuery attribute in order to access down the line
    this.$el.data('view', this);

    this.$el.on('afterChange init', this.onCarouselAfterChange.bind(this));
    this.getDataAttributes();
    // Only initialise if not in editor mode
    if (!this.options.editorMode) {
      // Only initialise once all of the the background images have loaded
      this.waitForBackgroundImages(this.initialiseCarousel);
    }
  },

  events: {
    'click .CarouselModule-prev': 'previousCarousel',
    'click .CarouselModule-next': 'nextCarousel'
  },

  getDataAttributes: function() {
    var attributes = ['autoplay', 'pagination', 'easing', 'speed', 'delay'];

    _.each(attributes, (attr) => {
      var data = this.$el.data(attr);
      if (data) {
        this.options[attr] = data;
      }
    });

    // Disable pagination and autoplay in editor mode
    var isEditorMode = this.$el.data('is-editor-mode');
    if (isEditorMode !== undefined) {
      this.options.editorMode = isEditorMode;
    }
  },

  waitForBackgroundImages: function(callback) {
    var carousel = this,
      $slides = this.$(this.options.slideClass),
      numSlides = $slides.length,
      imageFinished = function() {
        numSlides--;
        if (numSlides === 0) {
          callback.call(carousel);
        }
      };

    $slides.each(function() {
      // Try background image
      var src = $(this).css('background-image');

      if (src && src !== 'none') {
        // Fix css url
        src = src.replace(/^url\(['"]?/, '').replace(/['"]?\)$/, '');
      } else {
        // Try an image
        src = $(this).find('picture img').attr('src');
      }

      // No image source detected, just accept it as loaded
      if (!src) {
        imageFinished();
        return;
      }

      // Create image to pre-load
      var img = new Image();
      img.onload = imageFinished;
      img.onerror = imageFinished;
      img.src = src;

      // If image already loaded from cache
      if (img.complete) {
        imageFinished();
      }
    });
    if (EnableAdobeAnalytics.isEnabled()) {
      let currentUrl = window.location.href || undefined;
      if (currentUrl.indexOf('/products') === -1 && currentUrl.indexOf('/reference-designs') === -1 && currentUrl.indexOf('/datasheets') === -1) {
        let headerElement = $slides.find('.HeroCarousel-header') || undefined;
        if (currentUrl.indexOf('/verticals-and-trends') > 0) {
          let carousalName = headerElement.length > 0 ? $slides.find('.HeroCarousel-header')[0].innerText.trim() : undefined;
          Analytics.adobeCarousalImageImp(carousalName);
        } else {
          let carousalName = headerElement.length > 0 ? $slides.find('.HeroCarousel-header')[0].innerText.trim() : undefined;
          currentUrl = currentUrl.split('/').pop().trim() || undefined;
          if (currentUrl && carousalName) {
            this.getVerticalTrendList(currentUrl, carousalName);
          }
        }
      }
    }
  },

  isWithinBreakpoint: function() {

    // If no breakpoints are set (by default), skip all that
    if (!this.options.slickMaxBreakpoint && !this.options.slickMinBreakpoint) {
      return true;
    }

    var innerWidth = window.innerWidth;

    // If the max breakpoint is not set, compare to the min one only
    if (!this.options.slickMaxBreakpoint) {
      return innerWidth >= this.options.slickMinBreakpoint;
    }
    // If the min breakpoint is not set, compare to the max one only
    if (!this.options.slickMinBreakpoint) {
      return innerWidth <= this.options.slickMaxBreakpoint;
    }

    // When both breakpoints are set
    return innerWidth >= this.options.slickMinBreakpoint && innerWidth <= this.options.slickMaxBreakpoint;

  },

  initialiseCarousel: function() {
    if (this.isWithinBreakpoint()) {
      this.slick();
    }
    this.initialiseCarouselEvents();
  },

  slick: function() {
    if (this.slicked) return;

    // Initialise the slick carousel jquery plugin used for carousels
    // Slick.js Documentation => https://github.com/kenwheeler/slick
    let options = {
      pauseOnHover: true,
      pauseOnDotsHover: true,
      arrows: this.options.arrows,
      slide: this.options.slideClass,
      slidesToShow: this.options.slidesToShow,
      slidesToScroll: this.options.slidesToScroll,
      swipeToSlide: this.options.swipeToSlide,
      draggable: this.options.draggable,
      swipe: this.options.swipe,
      touchMove: this.options.touchMove,
      fade: this.options.fade,
      infinite: this.options.infinite,
      dots: this.options.pagination,
      dotsClass: this.options.paginationClass,
      autoplay: this.options.autoplay,
      easing: this.options.easing,
      cssEase: this.options.easing,
      speed: this.options.speed,
      autoplaySpeed: this.options.delay,
      customPaging: this.options.customPaging,
      prevArrow: this.options.prevArrow,
      nextArrow: this.options.nextArrow,
      responsive: this.options.responsive,
      mobileFirst: this.options.mobileFirst,
      asNavFor: this.options.asNavFor,
      focusOnSelect: this.options.focusOnSelect,
      variableWidth: this.options.variableWidth,
      respondTo: this.options.respondTo,
      touchThreshold: this.options.touchThreshold,
      vertical: this.options.vertical
    };

    if (!this.options.accessibility)
      options.accessibility = false;
    this.$el.slick(options);

    let baseView = this;
    $(window).on('resize', function() { baseView.onResize(); });
    this.slicked = true;
    this.onResize();
  },

  resizeCarosalContent: function($slide) {
    if ($slide && $slide.length) {
      var $contentDiv = $slide.find('.HeroCarousel-content');
      var $bodyDiv = $slide.find('.HeroCarousel-body');
      var $slideCtaDiv = $slide.find('.HeroCarousel-slide-cta');
      if ($contentDiv.length && $slideCtaDiv.length && $bodyDiv.length) {
        //resize using height adjustment
        var bodyDivPositionBottom = $bodyDiv[0].offsetTop + $bodyDiv[0].clientHeight;
        var slideCtaDivPositionTop = $slideCtaDiv[0].offsetTop;
        if (bodyDivPositionBottom > slideCtaDivPositionTop) {
          let diff = Math.floor(bodyDivPositionBottom - slideCtaDivPositionTop);
          if (diff < 15) {
            $contentDiv.css('padding-top', (15 - diff) + 'px');
          } else if (diff < 20) {
            $contentDiv.css('padding-top', '0px');
            $slideCtaDiv.css('bottom', '10px');
          } else {
            $contentDiv.css('padding-top', '0px');
            $slideCtaDiv.css('bottom', '5px');
          }
        }
        else {
          $contentDiv.css('padding-top', '');
          $slideCtaDiv.css('bottom', '');
        }

        //resize using width adjustment
        let bodyDivWidth = $bodyDiv[0].clientWidth;
        let contentDivWidth = $contentDiv[0].clientWidth;
        do {
          bodyDivPositionBottom = $bodyDiv[0].offsetTop + $bodyDiv[0].clientHeight;
          slideCtaDivPositionTop = $slideCtaDiv[0].offsetTop;
          if (bodyDivPositionBottom > slideCtaDivPositionTop) {
            bodyDivWidth += 20;
            let diff = Math.floor(bodyDivPositionBottom - slideCtaDivPositionTop);
            if (diff > 0 && bodyDivWidth < contentDivWidth) {
              $bodyDiv.css('max-width', bodyDivWidth + 'px');
            }
            else {
              break;
            }
          }
          else {
            $bodyDiv.css('max-width', '');
            break;
          }
        } while (true);
      }
    }
  },

  onResize: function() {
    let baseView = this;
    $('.slick-slide').each(function() {
      var $slide = $(this);
      if ($slide.attr('aria-describedby') !== undefined) {
        let id = '#' + $slide.attr('aria-describedby');
        if (!$(id).length) {
          $slide.removeAttr('aria-describedby');
        }
      }

      baseView.resizeCarosalContent($slide);
    });
    if (typeof(baseView.modify) !== 'undefined') {
      baseView.modify(this.el.slick);
    }
  },

  unslick: function() {
    if (!this.slicked) return;

    this.$el.slick('unslick');
    this.slicked = false;
  },

  reslick: function() {
    this.unslick();
    this.slick();
  },

  initialiseCarouselEvents: function() {
    // Detect viewport change events to control autoplay
    if (this.options.disableAutoPlayWhenOutOfViewport && this.options.autoplay) {
      mediator.on(config.events.ui.resize, this.onViewportChange, this);
      mediator.on(config.events.ui.scroll, this.onViewportChange, this);
    } else if (this.options.slickMaxBreakpoint) {
      mediator.on(config.events.ui.resize, this.onViewportChange, this);
    }
    if (this.$el[0].slick) {
      if (this.$el.find('.slick-disabled') && this.$el.find('.CarouselModule-prev') && this.$el[0].slick.$prevArrow !== null) {
        if (this.$el[0].slick.$prevArrow && this.$el[0].slick.$prevArrow[0]) {
          this.$el[0].slick.$prevArrow[0].setAttribute('tabindex', -1);
          this.$el[0].slick.$nextArrow[0].removeAttribute('tabindex');
        }
      }
    }
    this.isButtonClicked = false;
  },

  onCarouselAfterChange: function(e, slick, currentSlide = 0) {
    if (slick && slick.$slides) {
      let slideElements = slick.$slides.toArray();
      this.updateProductImpressionState(slideElements, currentSlide);
      var field = document.getElementById('slideTags-1');
      if (field !== null) {
        field.focus();
        slideElements[0].focus();
      }
    }
  },

  getVerticalTrendList: function(url, carousalName) {
    var verticalTrendElement = document.querySelector('.verticalTrends').querySelectorAll('ul > li > a') || undefined;
    if (verticalTrendElement) {
      verticalTrendElement.forEach((item) => {
        if (url === item.href.split('/').pop().trim()) {
          Analytics.adobeCarousalImageImp(carousalName);
          return;
        }
      });
    }
  },

  previousCarousel: function() {
    var field = document.getElementById('slideTags-' + i + '');
    this.carouselChange();
    var slick = this.$el.slick('getSlick');
    if (slick) {
      if (slick.$prevArrow[0].ariaDisabled === 'true') {
        slick.$prevArrow[0].setAttribute('tabindex', -1);
        slick.$nextArrow[0].removeAttribute('tabindex');
        if (field !== null) {
          field.focus();
          field.firstElementChild.firstElementChild.firstElementChild.focus();
        }
      } else {
        slick.$prevArrow[0].removeAttribute('tabindex', 0);
        slick.$nextArrow[0].removeAttribute('tabindex');
      }
    }
  },

  nextCarousel: function() {
    this.carouselChange();
    var slick = this.$el.slick('getSlick');
    if (slick) {
      if (slick.$nextArrow[0].ariaDisabled === 'true') {
        slick.$nextArrow[0].setAttribute('tabindex', -1);
        slick.$prevArrow[0].removeAttribute('tabindex');
      } else {
        slick.$nextArrow[0].removeAttribute('tabindex');
        slick.$prevArrow[0].removeAttribute('tabindex');
      }
    }
  },

  carouselChange: function() {
    var slick = this.$el.slick('getSlick');
    var slideElements = slick.$slides.toArray();
    if (slideElements !== null) {
      for (var k = 0; k < slideElements.length; k++) {
        if (slideElements[k].className === 'CarouselModule-slide slick-slide') {
          slideElements[k].style = 'visibility : hidden';
          slideElements[k].setAttribute('tabindex', -1);
        } else {
          slideElements[k].style = 'visibility : visible';
          slideElements[k].removeAttribute('tabindex');
        }
      }
    }
  },

  /**
   * Trigger events for the state of any product slides
   *
   * @param slideElements
   * @param currentSlide
   */
  updateProductImpressionState: function(slideElements, currentSlide = 0) {
    let hiddenElements = slideElements
      .filter((el, i) => i !== currentSlide)
      .filter(ProductImpression.isProductImpressionElement);
    if (hiddenElements.length) {
      mediator.trigger(config.events.productImpressions.productElementsHidden, hiddenElements);
    }
    let currentElement = slideElements[currentSlide];
    if (ProductImpression.isProductImpressionElement(currentElement)) {
      mediator.trigger(config.events.productImpressions.productElementsVisible, [currentElement]);
    } else {
      currentElement = null;
    }
    if (currentElement || hiddenElements.length) {
      mediator.trigger(config.events.productImpressions.checkListElement, this.el);
    }
  },

  onViewportChange: function() {
    // Enable/disable slick
    if (this.isWithinBreakpoint()) {
      this.slick();
    } else {
      this.unslick();
    }

    var slickTrack = this.$('.slick-track').get(0);

    if (!slickTrack) {
      return;
    }
    var isInViewport = utilities.isElementPartiallyInViewport(slickTrack),
      isMouseOver = this.isMouseOver(),
      slick = this.$el.slick('getSlick');
    if (isInViewport && !isMouseOver && slick.options.autoplay) {
      if (slick.paused) {
        slick.play();
      }
    } else {
      if (!slick.paused) {
        slick.pause();
      }
    }
  },

  isMouseOver: function() {
    // Instead of using hover going to look for a property change on hover.
    if (this.$el.css('max-width') === '100%') {
      return true;
    }
  }
});

module.exports = CarouselBaseView;



// WEBPACK FOOTER //
// ./assets/components/Carousel/CarouselBaseView.js